import { render, staticRenderFns } from "./PnetMessageDetail.vue?vue&type=template&id=737688e5"
import script from "./PnetMessageDetail.vue?vue&type=script&lang=js"
export * from "./PnetMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./PnetMessageDetail.vue?vue&type=style&index=0&id=737688e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports